import { lazy, Suspense, useContext } from 'react'
import type { ComponentProps } from 'react'
import type TokenImageEditorInner from '@/components/TokenImageEditorInner'
import { WalletReadyContext } from '@/lib/walletContext'

/**
 * Client-only boundary for the creator token-photo editor.
 *
 * The inner editor uses wagmi `useWalletClient` so Save can open the connected
 * AppKit wallet sign modal. Loading it lazily keeps the Node prerender path
 * free of WalletConnect `require("ws")`.
 *
 * DO NOT convert this back into a static import.
 */
const TokenImageEditorInnerLazy = lazy(() => import('@/components/TokenImageEditorInner'))

type TokenImageEditorProps = ComponentProps<typeof TokenImageEditorInner>

function TokenImageEditor(props: TokenImageEditorProps) {
  const ready = useContext(WalletReadyContext)
  if (!ready)
    return null

  return (
    <Suspense fallback={null}>
      <TokenImageEditorInnerLazy {...props} />
    </Suspense>
  )
}

export default TokenImageEditor
